<template>
    <div>

        <div class="flex -mx-2 justify-between flex-wrap w-full">

            <div class="px-2 w-1/3">
                <div class="card p-3 text-center cursor-pointer" @click="changeFilter('total-teams')"
                     :class="{'bg-green-fw text-green-lightest' : filter === 'total-teams'}">
                    <div class="text-4xl">{{ stats.total_teams }}</div>
                    <div class="mt-2 text-black tracking-wide">Total Teams</div>
                </div>
            </div>

            <div class="px-2 w-1/3">
                <div class="card p-3 text-center cursor-pointer" @click="changeFilter('with-chargebee-account')"
                     :class="{'bg-green-fw text-green-lightest' : filter === 'with-chargebee-account'}">
                    <div class="text-4xl">{{ stats.with_chargebee_account }}</div>
                    <div class="mt-2 text-black tracking-wide">With ChargeBee Account</div>
                </div>
            </div>

            <div class="px-2 w-1/3">
                <div class="card p-3 text-center cursor-pointer" @click="changeFilter('without-chargebee-account')"
                     :class="{'bg-green-fw text-green-lightest' : filter === 'without-chargebee-account'}">
                    <div class="text-4xl">{{ stats.without_chargebee_account }}</div>
                    <div class="mt-2 text-black tracking-wide">Without ChargeBee Account</div>
                </div>
            </div>

        </div>


        <div class="flex items-center" v-if="loading">
            <b-spinner type="grow" label="Loading"></b-spinner>
            Loading
        </div>

        <div v-else>

            <div class="w-full">
                <div class="flex flex-wrap flex-lg-nowrap">

                    <div class="text-2xl text-grey-darkest mr-2 mb-2 mb-lg-0 block lg:inline w-full lg:w-auto"> Teams </div>

                    <div class="w-full md:w-2/3 flex">
                        <div class="bg-grey-lighter rounded-full w-full xl:w-1/3 items-center">
                            <input
                                type="search"
                                dusk="search-by-name"
                                class="bg-grey-lighter text-grey-darkest w-5/6 focus:outline-none p-2 rounded-full ml-3 text-sm"
                                placeholder="Search by name..."
                                v-model="team_keyword"
                                @input="debounceFilter"
                            />
                        </div>
                    </div>
                    
                </div>
            </div>

            <div class="card mt-2">

<!--            <div class="alert alert-warning">-->
<!--                Shared ID is the Team ID that will be used between Recurly, Customer Success Management Application, and-->
<!--                FollowUP CRM.-->
<!--            </div>-->

                <table class="table table-striped">
                    <thead>
                    <tr v-if="pagination.data.length > 0">
                        <th>Team</th>
                        <th>ChargeBee Account Code</th>
                        <th></th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-if="pagination.data.length > 0" v-for="(item, index) in pagination.data" :key="`${index}-chargebee-item`">
                        <td>
                            {{ item.name }}
    <!--                        <div class="text-muted text-xs">Shared ID: {{ item.uuid }}</div>-->
                        </td>
                        <td>
                            <span v-if="!item.edit">{{ item.chargebee ? item.chargebee.code : '' }}</span>
                            <span v-if="item.edit && loading_accounts" class="text-muted text-sm">Loading accounts...</span>
                            <select v-model="item.new" v-if="item.edit && !loading_accounts" class="form-control-sm"
                                    :disabled="item.saving">
                                <option value=""></option>
                                <option v-for="(item, idx) in chargebee_accounts" :value="item"
                                        :key="`${index}-${idx}-chargebee-account-select`">
                                    {{ item.code }}
                                </option>
                            </select>
                        </td>
                        <td>
                            <button class="btn btn-sm btn-secondary" @click="edit(item)" v-if="!item.edit">Edit</button>
                            <div v-if="!loading_accounts">
                                <button class="btn btn-sm btn-primary" @click="save(item)" v-if="item.edit"
                                        :disabled="item.saving">
                                    <span v-if="item.saving"><b-spinner small></b-spinner> Saving</span>
                                    <span v-else>Save</span>
                                </button>
                                <button class="btn btn-sm btn-link" @click="cancel(item)" v-if="item.edit"
                                        :disabled="item.saving">
                                    Cancel
                                </button>
                            </div>
                        </td>
                    </tr>
                    <tr v-if="pagination.data.length === 0">
                        <td colspan="6" style="text-align: center">
                            No Result Found!
                        </td>
                    </tr>
                    </tbody>
                </table>
                <div class="card-footer flex justify-center" v-if="pagination.data.length > 0">
                    <b-pagination
                        @change="getList"
                        v-model="pagination.current_page"
                        :total-rows="pagination.total"
                        :per-page="pagination.per_page"
                        first-text="First"
                        prev-text="Prev"
                        next-text="Next"
                        last-text="Last"
                    >
                    </b-pagination>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import axios from 'axios';

    export default {
        name   : 'chargebee',
        data() {
            return {
                filter          : 'total-teams',
                stats           : {},
                pagination      : {},
                page            : 1,
                loading         : true,
                chargebee_accounts: [],
                loading_accounts: true,
                team_keyword: '',
                team_keyword_timeout: null,
            }
        },
        created() {
            this.getStatus();
            this.getList();
            this.getChargeBeeAccounts();
        },
        methods: {
            getStatus() {
                axios.get(route('spark.kiosk.chargebee.stats'))
                    .then(({data}) => this.stats = data)
            },
            getList(page = 1) {
                this.page    = page;
                this.loading = true;
                axios.get(route('spark.kiosk.chargebee.list', {page: this.page, filter: this.filter, keyword: this.team_keyword}))
                    .then(({data}) => {
                        this.pagination = data;
                        this.loading    = false;
                    });
            },
            getChargeBeeAccounts() {
                axios.get(route('spark.kiosk.chargebee.accounts'))
                    .then(({data}) => {
                        this.loading_accounts = false;
                        this.chargebee_accounts = data;
                    })
            },
            changeFilter(filter) {
                this.filter = filter;
                this.getList(this.page);
            },
            edit(item) {
                if (!item.new) item.new = item.chargebee;

                item.edit = true;
                this.$forceUpdate();
            },
            cancel(item) {
                item.edit = false;
                this.$forceUpdate();
            },
            save(item) {

                let self = this;

                item.saving = true;
                this.$forceUpdate();

                Swal.fire({
                    title             : "Are you sure?",
                    icon              : "warning",
                    buttons           : true,
                    dangerMode        : true,
                    showCancelButton  : true,
                    confirmButtonColor: '#01B1AF',
                    confirmButtonText : 'I\'m sure!',
                    closeOnConfirm    : true,
                    closeOnCancel     : true,
                }).then((result) => {
                    if (!result.value) return;

                    axios.put(route('spark.kiosk.chargebee.update', {team: item.id}), item.new)
                        .then(() => {
                            item.saving  = false;
                            item.chargebee = item.new;
                            Swal.fire({
                                type : "success",
                                title: "Chargebee account updated!"
                            });
                            self.getStatus();
                        })
                        .catch((error) => {
                            item.saving = false;
                            Swal.fire({
                                type : "error",
                                title: error.response.data.error
                            });
                        }).finally(() => self.cancel(item));
                }).catch(() => this.cancel(item));
            },

            debounceFilter(event) {
                clearTimeout(this.team_keyword_timeout);
                this.team_keyword_timeout = setTimeout(() => {
                    this.filterByTeamName(event.target.value);
                }, 700, this);
            },

            filterByTeamName(name) {
                this.team_keyword = name;
                this.getList();
            },
        }
    }
</script>
